import type {PrepView} from '../components/PreparationShop';
import type {ShopCatalog} from '../components/ShopCatalogue';
export const PREVIEW_PARENT='https://precisionautotechnik.synology.me:8443';
export type CustomerPreviewSnapshot={preparation:PrepView;catalog:ShopCatalog;access:{active:boolean;associated:boolean;invitationSentAt:string|null;invitationAcceptedAt:string|null};updatedAt:string};
let snapshot:CustomerPreviewSnapshot|null=null;
export function setCustomerPreview(value:CustomerPreviewSnapshot|null){snapshot=value;}
export function isPreviewMessage(event:Pick<MessageEvent,'origin'|'source'|'data'>,parent:Window):boolean{
 return event.origin===PREVIEW_PARENT&&event.source===parent&&event.data?.type==='precision-customer-preview'&&!!event.data.snapshot?.preparation?.vehicle&&Array.isArray(event.data.snapshot?.catalog?.products);
}
// No network fallback, auth token or writable endpoint exists in this transport.
export async function customerPreviewFetch(path:string,init:RequestInit={}):Promise<Response>{
 const reply=(data:unknown,status=200)=>Response.json(data,{status});
 if((init.method||'GET').toUpperCase()!=='GET')return reply({error:'PREVIEW_READ_ONLY'},403);
 if(!snapshot)return reply({error:'PREVIEW_CLOSED'},410);
 if(path==='/api/v1/preparation')return reply(snapshot.preparation);
 if(path==='/api/v1/shop/catalog'||path==='/api/v1/shop/catalog/tvpf')return reply(snapshot.catalog);
 if(path==='/api/v1/shop/orders')return reply({orders:snapshot.preparation.orders});
 return reply({error:'PREVIEW_READ_ONLY'},403);
}
